module.exports = __webpack_public_path__ + "static/img/9.1be0123.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/9.png
// module id = baxf
// module chunks = 0